module.exports = __webpack_public_path__ + "img/pig-with-lipstick.1aa82a37.png";